export default __webpack_public_path__ + "static/media/juice-fruit-r-mobile.ca3fe931.png";